var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRotateIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.1509V14.1509H8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.1509L6.64 18.5109C8 19.6508 9.04437 20.3717 10.5048 20.7941C11.9652 21.2165 13.5089 21.2621 14.9917 20.9266C16.4745 20.5911 17.8482 19.8854 18.9845 18.8755C20.1209 17.8655 20.9828 16.5841 21.49 15.1509",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49 3.99756V9.99756H16.49",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49 9.99756L17.85 5.63756C16.49 4.49763 15.4456 3.77676 13.9852 3.35433C12.5247 2.9319 10.9811 2.88631 9.49828 3.22181C8.01546 3.55732 6.64179 4.26299 5.50546 5.27298C4.36912 6.28296 3.50716 7.56434 2.99999 8.99756",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRotateIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rotate-icon.f9187ac9.svg";
export { ForwardRef as ReactComponent };